import { decryptCellClass } from './cell-decrypt/decrypt-cell-class'

export function createCellClassName (params, cellClassName) {
  const decrypt = decryptCellClass(params)
  let classes = []
  if (typeof cellClassName === 'string') {
    classes.push(cellClassName)
  } else if (typeof cellClassName === 'function') {
    const val = cellClassName(params)
    if (Array.isArray(val)) {
      classes.push(...val)
    } else {
      classes.push(val)
    }
  }
  return [].concat(decrypt).concat(classes)
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/feature/cell-class.js